const SWITCHER_SELECTOR = '.currency-switcher';
const SWITCHER_SELECTOR2 = '.js-currency-filter';
const SWITCHER_SELECTOR_INTER = '.currency-switcher-inter';

const currencySwitcherButtons = document.querySelectorAll(SWITCHER_SELECTOR);
const currencySwitcherFilterButtons = document.querySelectorAll(SWITCHER_SELECTOR2);
const isInternational = !!document.querySelector(SWITCHER_SELECTOR_INTER);
const cacheKey = isInternational ? 'gk_currency_inter_new' : 'gk_currency_new';

currencySwitcherButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        selectCurrency(btn.dataset.currency);
    });
});

currencySwitcherFilterButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
        selectCurrency(btn.value);
    });
});

function selectCurrency(currency) {
    if (!['PLN', 'EUR'].includes(currency)) {
         console.error(`Invalid currency: '${currency}'`);
         currency = isInternational ? 'EUR' : 'PLN';
         console.log('Currency set to ' + currency);
    }

    if (currency === 'PLN') {
        setCurrencyStyle('.currency-pln', 'display:block');
        markCurrency(`${SWITCHER_SELECTOR}[data-currency='PLN']`, true);
        setCurrencyStyle('.currency-eur', 'display:none');
        markCurrency(`${SWITCHER_SELECTOR}[data-currency='EUR']`, false);
    } else if (currency === 'EUR') {
        setCurrencyStyle('.currency-pln', 'display:none');
        markCurrency(`${SWITCHER_SELECTOR}[data-currency='PLN']`, false);
        setCurrencyStyle('.currency-eur', 'display:block');
        markCurrency(`${SWITCHER_SELECTOR}[data-currency='EUR']`, true);
    }

    storeCurrency(currency);
    selectCurrencyForFilters(currency);
}

function selectCurrencyForFilters(currency) {
    if (currency === 'PLN') {
        markRadioCurrency(`${SWITCHER_SELECTOR2}[value='PLN']`);
    } else if (currency === 'EUR') {
        markRadioCurrency(`${SWITCHER_SELECTOR2}[value='EUR']`);
    }
}

function setCurrencyStyle(selector, style) {
    const items = document.querySelectorAll(selector);
    if (items.length) {
        items.forEach((item) => {
            item.style = style;
        });
    }
}

function markCurrency(selector, isActive) {
    const items = document.querySelectorAll(selector);
    if (items.length) {
        items.forEach((item) => {
            if (isActive) {
                item.classList.add('currency-switcher--active');
            } else {
                item.classList.remove('currency-switcher--active');
            }
        });
    }
}

function markRadioCurrency(selector) {
    const items = document.querySelectorAll(selector);
    if (items.length) {
        items.forEach((item) => {
            item.checked = true;
        });
    }
}

function storeCurrency(currency) {
    localStorage.setItem(cacheKey, currency)
}

function getStoredCurrency() {
    // Always show EUR for international offers
    if (isInternational) {
        return 'EUR';
    }
    return localStorage.getItem(cacheKey);
}

window.onload = function() {
    selectCurrency(getStoredCurrency());
};
